import $ from 'jquery';

(function () {
  'use strict';

  const $form = $('[data-counterpart-form]');

  const exports = {
    initialize: function () {
      let defaultAction = '';

      $form.on('submit', function () {
        defaultAction = $(this).attr('action');
        let action = defaultAction;
        const value = $(this).find('[data-counterpart-select]').val();

        if (value.startsWith('#')) {
          action = action + value;
        } else {
          action = defaultAction;
        }

        $(this).attr('action', action);
      });
    }
  };

  exports.initialize();
})();
